import {
  Component,
  Event,
  EventEmitter,
  h,
  Method,
  Prop,
  State,
} from "@stencil/core";
import store, { createCart } from "@stores/cart.store";
import { AddToCartButtonProps } from "../../bcp-add-to-cart/bcp-add-to-cart-model";
import config from "../../../../environment/environment-config";
import { AddToCartEvent } from "@apis/model/add-to-cart-event";
import { startWatchingFocusOutAndClick } from "@globals/helpers/focus-helpers";
import { BcpMulticartSelectorState } from "./bcp-multicart-selector-model";

@Component({
  tag: "bcp-multicart-selector",
  styleUrl: "bcp-multicart-selector.scss",
  shadow: true,
})
export class BcpMulticartSelector {
  @Prop() createCartLabel: AddToCartButtonProps["createCartLabel"] =
    "Create new cart";

  @Prop({ mutable: true })
  flyoutDirection: AddToCartButtonProps["flyoutDirection"] = "down";

  @Prop() productCode: AddToCartButtonProps["productCode"];

  @State() isOpen: BcpMulticartSelectorState["isOpen"] = false;

  @Method()
  async toggleCartSelector(): Promise<void> {
    this.isOpen = !this.isOpen;
  }

  @Event() addedToSelectedCart: EventEmitter<AddToCartEvent>;

  componentWillRender(): void {
    this.closeFlyoutController = new AbortController();
    if (this.isOpen) {
      startWatchingFocusOutAndClick(
        this.flyout,
        this.closeFlyoutController,
        () => (this.isOpen = false)
      );
    }
  }

  private flyout: HTMLElement;

  private closeFlyoutController: AbortController;

  private maximumCartsAllowed: number = config.cartConfig.maximumCarts;

  private addProductToCart = (cart) => {
    this.addedToSelectedCart.emit({
      cart,
      productCode: this.productCode,
    });
  };

  private createCartWithProduct = () => {
    createCart().then((cart) => {
      this.addProductToCart(cart);
    });
  };

  render() {
    return (
      this.isOpen && (
        <div
          ref={(el) => (this.flyout = el)}
          class={`flyout flyout--direction-${this.flyoutDirection}`}
        >
          {store.loading && <bcp-activity-indicator is-inline is-absolute />}
          <ul class="flyout__cart-list">
            {store.carts.map((cart) => (
              <li key={cart.code}>
                <f-button
                  variant="tertiary"
                  fullWidth={true}
                  onClick={() => {
                    this.addProductToCart(cart);
                  }}
                  notCentered={true}
                >
                  {cart.name ?? cart.code}
                </f-button>
              </li>
            ))}
            {store.carts.length < this.maximumCartsAllowed && (
              <li>
                <f-button
                  variant="tertiary"
                  fullWidth={true}
                  onClick={this.createCartWithProduct}
                  notCentered={true}
                >
                  {this.createCartLabel}
                </f-button>
              </li>
            )}
          </ul>
        </div>
      )
    );
  }
}
